/* eslint-disable prettier/prettier */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import React from 'react';

function DeleteRecordDialog(props) {
  const { isOpen, title, dsc, handleClose, handleConfirm } = props;
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{dsc}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Anuluj</Button>
        <Button color="error" onClick={handleConfirm}>
          Usuń
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteRecordDialog;
